module.exports = __webpack_public_path__ + "img/Weapon_14.bfca4fdd.png";